(function () {
  'use strict';

  // Scroll-reveal for any .cozikat-reveal element (homepage sections).
  var revealTargets = document.querySelectorAll('.cozikat-reveal');
  if (revealTargets.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('cozikat-in');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
      );
      revealTargets.forEach(function (el) {
        io.observe(el);
      });
    } else {
      revealTargets.forEach(function (el) {
        el.classList.add('cozikat-in');
      });
    }
  }

  // Adds a subtle shadow to the sticky header once the page has scrolled,
  // matching the brand mockup. Additive only — does not touch Dawn's own
  // sticky-header show/hide behavior.
  var headerWrapper = document.querySelector('.header-wrapper');
  if (headerWrapper) {
    var onScroll = function () {
      headerWrapper.classList.toggle('cozikat-header-scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Give text-based calls to action one consistent brand treatment without
  // changing purpose-specific controls such as close, carousel, tab, search,
  // quantity, or media buttons.
  var actionSelector = [
    'a.button:not(.button--tertiary):not(.skip-to-content-link)',
    'button.button:not(.button--tertiary):not(.button-close)',
    '.shopify-challenge__button',
    '.customer button',
    '.shopify-payment-button__button--unbranded',
    '.cozikat-btn',
    '.cozikat-quiz__button',
    '.cozikat-quiz__retake',
    '.cozikat-quiz__check-now',
    '.ecom-product-single__add-to-cart--submit'
  ].join(',');

  var enhanceAction = function (action) {
    if (!(action instanceof Element)) return;

    action.classList.add('ck-action-button');
  };

  var enhanceActions = function (root) {
    if (!(root instanceof Element || root instanceof Document || root instanceof DocumentFragment)) return;

    if (root instanceof Element && root.matches(actionSelector)) enhanceAction(root);
    root.querySelectorAll(actionSelector).forEach(enhanceAction);
  };

  enhanceActions(document);

  if ('MutationObserver' in window) {
    var actionObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.target instanceof Element && mutation.target.matches(actionSelector)) {
          enhanceAction(mutation.target);
        }
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE) enhanceActions(node);
        });
      });
    });

    actionObserver.observe(document.body, { childList: true, subtree: true });
  }
})();
